<template>
  <div class="text-center alert-section">
    <div class="mt-4">
      <div v-if="Number(surveyStatusId) === 2" class="bg-warning alert">
        {{ screentexts[90] ? screentexts[90].element_text : 'Scheduled: ' }}
        {{ formatDate(surveyStartDate) }}
      </div>
      <div v-if="Number(surveyStatusId) === 3" class="bg-secondary alert">
        {{
          surveyEndDate > '1970-01-02'
            ? `${screentexts[91] ? screentexts[91].element_text : 'Active until: '} ${formatDate(surveyEndDate)}`
            : 'Incorrect survey status'
        }}
      </div>
      <div v-if="Number(surveyStatusId) === 4" class="bg-primary alert">
        {{ screentexts[92] ? screentexts[92].element_text : 'Completed' }}
      </div>
    </div>
    <div class="d-none d-xl-inline-block">
      <Chart :sub="completecount" :total="membercount" />
    </div>
    <br>
    <div v-show="Number(hasPaper) === 1" class="col-12 text-center">
      <button
        class="btn btn-primary text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2 d-none d-lg-inline-block"
        @click.prevent="$emit('print-paperforms')"
      >
        {{ screentexts[113] ? screentexts[113].element_text : 'Print all paper forms' }}
      </button>
      <br>
    </div>
    <div v-if="surveyStatusId < 3" class="col-12 mx-auto">
      <button
        class="btn btn-primary text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        :disabled="surveyStatusId < 2"
        @click.prevent="$emit('launch')"
      >
        {{ screentexts[114] ? screentexts[114].element_text : 'Launch survey now!' }}
      </button>
    </div>
    <div v-if="Number(surveyStatusId) === 3 && completecount > 0" class="col-12 mx-auto">
      <button
        class="btn btn-danger text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        @click.prevent="$emit('close-ask')"
      >
        {{ screentexts[115] ? screentexts[115].element_text : 'Close survey' }}
      </button>
      <br>
    </div>
    <div v-if="Number(surveyStatusId) === 4" class="col-12 mx-auto">
      <button
        class="btn btn-secondary text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        @click.prevent="$emit('reopen')"
      >
        {{ screentexts[116] ? screentexts[116].element_text : 'Re-open survey' }}
      </button>
      <br>
      <button
        v-if="spotify === '0'"
        class="btn btn-primary text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        @click.prevent="$emit('report')"
      >
        {{ screentexts[117] ? screentexts[117].element_text : 'Download report' }}
      </button>
      <button
        v-if="spotify === '1'"
        class="btn btn-primary text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        @click.prevent="$emit('report')"
      >
        Download Spotify report
      </button>
      <br>
    </div>
    <div v-if="asadmin" class="col-12 mx-auto">
      <button
        class="btn btn-danger text-center col-12 col-sm-8 col-md-6 col-lg-5 col-xl-12 my-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse-1"
        aria-expanded="false"
        aria-controls="collapse-1"
      >
        <fa-icon class="mr-4" icon="skull-crossbones" />
        Show admin functions
      </button>
    </div>
  </div>
</template>

<script>
import Chart from './styleguide/Chart.vue'

export default {
  name: 'GroupSurveyStatusPanel',
  components: { Chart },
  props: {
    surveyStatusId: { type: Number, default: 0 },
    surveyStartDate: { type: String, default: null },
    surveyEndDate: { type: String, default: null },
    completecount: { type: Number, default: 0 },
    membercount: { type: Number, default: 0 },
    hasPaper: { type: [Number, String], default: 0 },
    spotify: { type: String, default: '0' },
    asadmin: { type: Boolean, default: false },
    screentexts: { type: Array, default: () => [] }
  },
  emits: ['print-paperforms', 'launch', 'close-ask', 'reopen', 'report'],
  methods: {
    formatDate (date) {
      if (!date) return ''
      if (date instanceof Date) return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
      return String(date).substring(0, 10)
    }
  }
}
</script>
